<div class="container">
  <image-cropper
    [imageBase64]="imageToCrop"
    [maintainAspectRatio]="true"
    [aspectRatio]="3 / 3"
    format="png"
    (imageCropped)="imageCropped($event)"
    outputType="base64"
  ></image-cropper>

  <ion-toolbar>
    <ion-buttons slot="primary">
      <ion-button color="secondary" (click)="save()">
        <ion-icon slot="icon-only" name="checkmark-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="secondary">
      <ion-button (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</div>
